import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import FileView from '../views/FilesView.vue'
import uploadfileView from '../views/uploadfileView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/main',
    name: 'home',
    component: HomeView
  },
  {
    path:"/",
    name: 'login',
    component:LoginView
  },
  {
    path:"/files",
    name:"files",
    component:FileView
  },
{
    path:"/uploadfiles",
    name:"Uploadfiles",
    component:uploadfileView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
